export const kioskSimulator = {
  name: 'Simulador de Kiosco |||| Simuladores de Kiosco',
};
export default kioskSimulator;